// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/FAQborder.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accordion styles */
.accordion {
    /* border: 1px solid #ccc; */
    width: 89%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
  }
  
  /* Styling for accordion headers */
  .accordion-header {
    cursor: pointer;
    padding: 10px;
    color: #000;
    font-family: PP NeueBit;
    font-size: 65.07px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 20px;

  }
  
  /* Styling for active (open) accordion headers */
  .accordion-header.active {
    color: black;
  }
  
  /* Styling to hide accordion content by default */
  .accordion-content {
    width: 75%;
    /* display: none; */
    /* opacity: 0; */
    color: 'black';
  font-size: 28px;
  font-family: 'N27';
  font-weight: '400';
  word-wrap: 'break-word';
  /* margin-bottom: 50px; */
  max-height: 0;
  overflow: hidden;
  transition:  max-height 0.4s ease-in-out, margin 0.4s ease-in-out;
  text-align: left;
  }
  
  /* Styling for active (open) accordion content */
  .accordion-content.active {
    content: "this is the content";
    max-height: 500px;
    /* opacity: 1; */
    margin-bottom: 50px;
    color: black;
    max-height: 500px;
    
  }

  .accordion-border{ 
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 10px;
    background-repeat: no-repeat;
    width: 100%;
    margin: 20px 0;
    
  }

  @media only screen and (max-width: 600px){
    .accordion-header{
      font-weight: 100;
      font-size: 35px;
      margin: 5px;
    }
    .accordion-content{
      width: 100%;
      font-size: 15px;
      /* font-weight: 500; */
      /* margin-bottom:15px ; */
    }
    .accordion-content.active{
      margin-bottom: 15px;
    }
    .accordion-border{
      margin: 10px 0;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Accordion/Accordion.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,4BAA4B;IAC5B,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;EAErB;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;;EAEd;;EAEA,gDAAgD;EAChD;IACE,YAAY;EACd;;EAEA,iDAAiD;EACjD;IACE,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,iEAAiE;EACjE,gBAAgB;EAChB;;EAEA,gDAAgD;EAChD;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;;EAEnB;;EAEA;IACE,yDAA0D;IAC1D,YAAY;IACZ,4BAA4B;IAC5B,WAAW;IACX,cAAc;;EAEhB;;EAEA;IACE;MACE,gBAAgB;MAChB,eAAe;MACf,WAAW;IACb;IACA;MACE,WAAW;MACX,eAAe;MACf,sBAAsB;MACtB,yBAAyB;IAC3B;IACA;MACE,mBAAmB;IACrB;IACA;MACE,cAAc;IAChB;EACF","sourcesContent":["/* Accordion styles */\n.accordion {\n    /* border: 1px solid #ccc; */\n    width: 89%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    \n  }\n  \n  /* Styling for accordion headers */\n  .accordion-header {\n    cursor: pointer;\n    padding: 10px;\n    color: #000;\n    font-family: PP NeueBit;\n    font-size: 65.07px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin: 20px;\n\n  }\n  \n  /* Styling for active (open) accordion headers */\n  .accordion-header.active {\n    color: black;\n  }\n  \n  /* Styling to hide accordion content by default */\n  .accordion-content {\n    width: 75%;\n    /* display: none; */\n    /* opacity: 0; */\n    color: 'black';\n  font-size: 28px;\n  font-family: 'N27';\n  font-weight: '400';\n  word-wrap: 'break-word';\n  /* margin-bottom: 50px; */\n  max-height: 0;\n  overflow: hidden;\n  transition:  max-height 0.4s ease-in-out, margin 0.4s ease-in-out;\n  text-align: left;\n  }\n  \n  /* Styling for active (open) accordion content */\n  .accordion-content.active {\n    content: \"this is the content\";\n    max-height: 500px;\n    /* opacity: 1; */\n    margin-bottom: 50px;\n    color: black;\n    max-height: 500px;\n    \n  }\n\n  .accordion-border{ \n    background-image: url(\"../../assets/Images/FAQborder.svg\");\n    height: 10px;\n    background-repeat: no-repeat;\n    width: 100%;\n    margin: 20px 0;\n    \n  }\n\n  @media only screen and (max-width: 600px){\n    .accordion-header{\n      font-weight: 100;\n      font-size: 35px;\n      margin: 5px;\n    }\n    .accordion-content{\n      width: 100%;\n      font-size: 15px;\n      /* font-weight: 500; */\n      /* margin-bottom:15px ; */\n    }\n    .accordion-content.active{\n      margin-bottom: 15px;\n    }\n    .accordion-border{\n      margin: 10px 0;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
